import React, {useState} from "react";
import {Box, Button, Columns, Form, Icon} from "react-bulma-components";
import Collapsible from "react-collapsible";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TransactionReportingCategoryPicker
    from "../Transactions/TransactionReportingCategories/TransactionReportingCategoryPicker";
import TrackingOptionsPicker from "../TrackingCategory/TrackingOptionsPicker";


export default function NewMovementType({onSave, trackingOptions, trackingOptionObjects}){
    const [type, setType] = useState({
        name: "",
        trackingOption: trackingOptionObjects[Object.keys(trackingOptionObjects)[0]],
        invoice_address: "start"
    })
    const onChange = e => {
        let newType = {...type, [e.target.name]: e.target.value}
        setType(newType);
    };

    const onTrackingOptionChange = e => {
        let newType = {...type, ["tracking_option"]: trackingOptionObjects[e.target.value]}
        setType(newType);
    };
    return (
        <Box>
            <Collapsible
                className={"title"}
                trigger={"Add Movement Type"}
                triggerOpenedClassName={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Name</Form.Label>
                            <Form.Input
                                name={"name"}
                                type={"text"}
                                onChange={onChange}
                                value={type.name}
                            />
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <TrackingOptionsPicker
                            name={"tracking_option"}
                            label={"Tracking Option"}
                            onChange={onTrackingOptionChange}
                            inlineEdit={false}
                            editable={true}
                            options={trackingOptions}
                            value={type.tracking_option}
                            blank={true}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Invoice Address</Form.Label>
                        <Form.Select
                            name={"invoice_address"}
                            onChange={onChange}
                            value={type.invoice_address}
                        >
                            <option key={0} value={"start"}>START</option>
                            <option key={1} value={"end"}>END</option>
                        </Form.Select>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={() => onSave(type)}
                            fullwidth
                        >
                            Create
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )


}